import { Navigate, Outlet, Route, Routes } from 'react-router';
import ToolsIndex from './pages/tools/index';

function App() {

  return (
    <div className="App">
        <Routes>
          <Route path="/tools/*" element={<ToolsIndex />} />
          <Route path="" element={<Navigate replace to="tools" />} />
        </Routes>
        <Outlet />
    </div>
  );
}

export default App;
